// src/api/mollie.js
import api from "./index";

/**
 * Récupère le statut de connexion Mollie du vétérinaire
 * @returns {Promise} Réponse de l'API avec les informations de statut Mollie
 */
export function getMollieSellerStatus() {
  return api.get("/mollie/seller-status");
}
